/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UserInfoDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class UserService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags UserService
   * @name GetMyAccount
   * @summary Get My Account
   * @request GET:/v1/users/me
   * @secure
   */
  getMyAccount = (params: RequestParams = {}) =>
    this.http.request<UserInfoDto, any>({
      path: `/v1/users/me`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags UserService
   * @name DeleteMyAccount
   * @summary Delete My Account
   * @request DELETE:/v1/users/me
   * @secure
   */
  deleteMyAccount = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/users/me`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
}
